<template>
    <div v-if="toolboxCandidateUrl" class="alertAira margin-bot">
        <div class="row margin-none valign-wrapper">
            <div class="col m7 s12">
                <p class="alertInfo__info">
                        <i class="fa fa-check-circle green-text margin-right-small" aria-hidden="true"></i><span class="bold">{{$t('applications.toolbox.title')}}</span><br>
                        {{$t('applications.toolbox.text')}}
                </p>
            </div>
            <div class="col m5 right-align hide-on-small-only">
                <a :href="toolboxCandidateUrl" target="_blank" class="btnSecondary">{{$t("applications.toolbox.action")}}</a>
            </div>
            <div class="col s12 right-align hide-on-med-and-up">
                <a :href="toolboxCandidateUrl" target="_blank" class="btnSecondary-s">{{$t("applications.toolbox.action")}}</a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "ApplicationToolBoxMessage",
    props: {
        toolboxCandidateUrl: {
            type: String,
            default: ''
        },
    },
}
</script>